import { useEffect, useState } from "react"
import { useParams,useNavigate, useLocation } from 'react-router-dom'
import APIUrls from "../../../services/APIUrls";
import { getAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import { useRef } from "react";
import jQuery from "jquery";
import { ConditionalBlock } from "../../../ConditionalBlock";

export default function LeveragedTmView(prop) {

    const params = useParams()
    const [translationUnits, setTranslationUnits] = useState([])
    const [sourceLanguage, setSourceLanguage] = useState("")
    const [targetLanguage, setTargetLanguage] = useState("")
    const [assetName, setAssetName] = useState("")
    const [tmCount, setTmCount] = useState(0)
    const navigate = useNavigate();
 

    useEffect(()=>{     
      getAxiosResponse(APIUrls.PROJECT(params.id)).then((res)=>{ 
         const projectResource = res.data.data.resource.projectResource;
         const additionalProjectInfo = res?.data?.data?.displayName[0];                                 
         const filteredProjectAsset = projectResource.projectAssets.find(projectAsset=>projectAsset.id==params.projectAssetId)
         if(filteredProjectAsset){            
            setAssetName(filteredProjectAsset.assets[0].name);                        
         }
         const filteredTargetLanguage = additionalProjectInfo.targetLanguages.find(targetLanguage=>targetLanguage.code == params.targetLanguage);         
         setSourceLanguage(additionalProjectInfo.sourceLanguage.display)
         if(filteredTargetLanguage){
            setTargetLanguage(filteredTargetLanguage.display);            
         }
       })           
        getAxiosResponse(APIUrls.LEVERAGED_TU(params.id,params.projectAssetId,params.targetLanguage)).then(res=>{    
               const translationUnitArray  =  res.data.data;                                  
                setTranslationUnits(translationUnitArray);
        })
        getAxiosResponse(APIUrls.CUSTOMER_TRANSLATION_UNIT_SOURCE_SEGMENT_STATUS(params.id,params.projectAssetId,params.targetLanguage)).then(res=>{            
            setTmCount(res.data.data.LEVERAGED_TUS);
        })
              
    },[])

   

    useEffect(()=>{        
      jQuery("#line-by-line-view-content .video-translated-content li").height("");
        var lineHeight = 0;
        jQuery("#line-by-line-view-content .video-translated-content li").each(function(){
        if (jQuery(this).height() > lineHeight) { 
          lineHeight = jQuery(this).height(); 
          }
        });          
        jQuery("#line-by-line-view-content .video-translated-content li").height(lineHeight);
      },[translationUnits])


    function navigateBack(){    
        navigate(`/project/${params.id}`,{state: {tab : "leverage-tm", langCode:params.targetLanguage}})
    }

    return (
      <div >          
         <header id="openHeader-Menu" class="header flex-center">
   <div class="left-logo flex-center">
      <div class="logo-text">
         <span>{assetName}</span>
         <div class="logo-text-inner flex-center">
            <button aria-label="back" class="back-btn" onClick={navigateBack}>
               <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
                  <path d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z" fill="#1D4ED8"></path>
               </svg>
            </button>         
         </div>
      </div>
   </div>
   
</header>
<section>
<div id="content" class="main-content">
   <div class="icr-menu flex-center">
   <div class="icr-menu-left">
      <ul class="flex-center">
         <li>
            <div class="hide-show">
            </div>
         </li>
         <li class="m-hide">
            <div class="source flex-center"><span>Source - {sourceLanguage}</span></div>
         </li>
         <li>            
         </li>
      </ul>
   </div>
   <div class="icr-menu-right">
      <ul class="flex-center">
         <li>
            <div class="preview-outer"><button aria-label="line by line" class="preview flex-center active" id="line-by-line">Line-By-Line</button></div>
         </li>
         <li class="m-hide">
            <div class="source flex-center"><span>Target - {targetLanguage}</span></div>
         </li>
         <li>
            
         </li>
      </ul>
   </div>
</div>
        
<div id="line-by-line-view-content" class="icr-content-inner line-text flex-center resizable-x">   
   <div class="icr-content-inner-left relative" onScroll={()=>{      
      const scrollPosition = jQuery(".icr-content-inner-left").scrollTop();
      jQuery(".icr-content-inner-right").scrollTop(scrollPosition);
      }}>
      <div class="translate-content new-content video-main line-content">
         
         <ul class="video-translated-content">
         {translationUnits.map(translationUnit=>
         <ConditionalBlock condition={translationUnit.srcText}>
         <li > 
         <strong class="mr-15">{translationUnit.docSegPos}</strong>        
         <span>
            <g id="1">{translationUnit.srcText} </g>
         </span>
      </li>
      </ConditionalBlock>
      )}                      
         </ul>
      </div>
   </div>
   <div class="splitter resizer-x">
      <button aria-label="drag content" class="splitter-icon" tabindex="-1">
         <svg xmlns="http://www.w3.org/2000/svg" width="27" height="29" viewBox="0 0 27 29" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2344 7.00634C12.2344 7.40036 12.3677 7.77824 12.6051 8.05686C12.8424 8.33547 13.1643 8.492 13.5 8.492C13.8357 8.492 14.1576 8.33547 14.3949 8.05686C14.6323 7.77824 14.7656 7.40036 14.7656 7.00634V2.05414C14.7656 1.66012 14.6323 1.28224 14.3949 1.00362C14.1576 0.725006 13.8357 0.568481 13.5 0.568481C13.1643 0.568481 12.8424 0.725006 12.6051 1.00362C12.3677 1.28224 12.2344 1.66012 12.2344 2.05414V7.00634ZM20.52 8.92779C20.7573 8.64958 21.079 8.49331 21.4144 8.49331C21.7498 8.49331 22.0714 8.64958 22.3088 8.92779L26.1056 13.3848L27 14.4346L26.1056 15.4845L22.3088 19.9415C22.0688 20.2039 21.7515 20.3468 21.4236 20.34C21.0957 20.3332 20.7829 20.1773 20.551 19.9051C20.3191 19.6329 20.1863 19.2657 20.1805 18.8808C20.1747 18.4959 20.2964 18.1234 20.52 17.8418L23.4225 14.4346L20.52 11.0275C20.283 10.749 20.1499 10.3714 20.1499 9.97766C20.1499 9.58396 20.283 9.20635 20.52 8.92779ZM13.5 18.3964C13.1643 18.3964 12.8424 18.2399 12.6051 17.9613C12.3677 17.6826 12.2344 17.3048 12.2344 16.9107V11.9585C12.2344 11.5645 12.3677 11.1866 12.6051 10.908C12.8424 10.6294 13.1643 10.4729 13.5 10.4729C13.8357 10.4729 14.1576 10.6294 14.3949 10.908C14.6323 11.1866 14.7656 11.5645 14.7656 11.9585V16.9107C14.7656 17.3048 14.6323 17.6826 14.3949 17.9613C14.1576 18.2399 13.8357 18.3964 13.5 18.3964ZM13.5 28.3008C13.1643 28.3008 12.8424 28.1443 12.6051 27.8657C12.3677 27.587 12.2344 27.2092 12.2344 26.8151V21.8629C12.2344 21.4689 12.3677 21.091 12.6051 20.8124C12.8424 20.5338 13.1643 20.3773 13.5 20.3773C13.8357 20.3773 14.1576 20.5338 14.3949 20.8124C14.6323 21.091 14.7656 21.4689 14.7656 21.8629V26.8151C14.7656 27.2092 14.6323 27.587 14.3949 27.8657C14.1576 28.1443 13.8357 28.3008 13.5 28.3008ZM4.69125 8.92779C4.93117 8.66537 5.2485 8.5225 5.57638 8.52929C5.90426 8.53608 6.2171 8.692 6.44899 8.9642C6.68087 9.2364 6.8137 9.60362 6.81948 9.98851C6.82527 10.3734 6.70356 10.7459 6.48 11.0275L3.5775 14.4346L6.48 17.8418C6.60435 17.9778 6.70408 18.1418 6.77326 18.324C6.84243 18.5063 6.87962 18.703 6.88262 18.9025C6.88562 19.1019 6.85436 19.3001 6.79071 19.4851C6.72705 19.6701 6.63231 19.8381 6.51213 19.9792C6.39195 20.1203 6.24879 20.2315 6.0912 20.3062C5.9336 20.3809 5.7648 20.4176 5.59487 20.4141C5.42493 20.4106 5.25734 20.3669 5.10209 20.2857C4.94684 20.2045 4.80712 20.0874 4.69125 19.9415L0.894375 15.4845L0 14.4346L0.894375 13.3848L4.69125 8.92779Z" fill="#1D4ED8"></path>
         </svg>
      </button>
   </div>   
   <div class="icr-content-inner-right relative" onScroll={()=>{      
      const scrollPosition = jQuery(".icr-content-inner-right").scrollTop();
      jQuery(".icr-content-inner-left").scrollTop(scrollPosition);
      }}>
      <div class="translate-content new-content video-main line-content">
         <div class="filter-text flex-center">
            <div className="filter-box flex-center tm">
                                <button aria-label="tm" className="flex-center">
                                    <p className="number" id="TM-count"> {tmCount}</p>
                                    <p className="text">TM</p>
                                </button>
            </div>
         </div>
         <ul class="video-translated-content">
         {translationUnits.map(translationUnit=>
         <ConditionalBlock condition={translationUnit.srcText}>
         <li>
               <span class="outsideContext">
                  <span role="link" aria-expanded="false" tabindex="0" id="655ef5c8ba1b801623b93daa" class="linebykeydown">
                     <span>
                        {translationUnit.srcText !== translationUnit.translations[0].text ? 
                        <g id="1">{translationUnit.translations[0].text} </g>:<g id="1"></g>}                                                                      
                     </span>
                  </span>
               </span>
            </li>
            </ConditionalBlock>
            )}             
         </ul>
      </div>
   </div>
</div>
</div>
</section>

        </div>
        
    )

}